import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const PremiumMemberAlert = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  const handleNavigateToPricing = () => {
    navigate('/pricing', { state: { FromLimitedTender: 'FromLimitedTender' } });
    window.scrollTo(0, 0);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-15 z-50 text-xs md:text-sm">
      <div className="bg-white rounded-lg p-6 shadow-lg text-center max-w-lg md:w-auto w-80 relative">
        <button
          onClick={onClose}
          className="absolute text-sm md:text-lg top-2 right-2 text-gray-500 hover:text-gray-700"
        >
          &times;
        </button>
        <h2 className="md:text-xl text-sm font-bold text-gray-800 mb-4">
          Premium Membership Required
        </h2>
        <p className="text-gray-600 md:mb-6 mb-4">
          To view full tender details, choose any of our packages and get
          regular updates on your tenders.
        </p>
        <button
          onClick={handleNavigateToPricing}
          className="bg-DefaultColor text-white py-1 px-4 rounded hover:bg-DefaultHoverColor"
        >
          Become Member
        </button>
      </div>
    </div>
  );
};
